import React from 'react';
import { node, func, string } from 'prop-types';

import { Link } from '@one-thd/sui-atomic-components';

export const ProductButtonText = ({ children, onClick, underline }) => {
  if (!onClick) {
    return (
      <>
        {children}
      </>
    );
  }
  return (
    <Link
      component="button"
      onClick={onClick}
      underline={underline}
    >
      {children}
    </Link>
  );
};

ProductButtonText.propTypes = {
  children: node.isRequired,
  onClick: func,
  underline: string
};

ProductButtonText.defaultProps = {
  onClick: () => {},
  underline: 'hover'
};